import { render } from "./EdgeVerdict.vue?vue&type=template&id=3e67920a"
import script from "./EdgeVerdict.vue?vue&type=script&lang=js"
export * from "./EdgeVerdict.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__